<template>
  <div>
    <BaseLabel class="mb-1">{{ label }}</BaseLabel>
    <div class="flex">
      <Multiselect
        :value="computedValue"
        :options="options"
        :searchable="searchable"
        :close-on-select="true"
        :placeholder="placeholder"
        :allow-empty="false"
        :label="selectLabel"
        :track-by="trackBy"
        :select-label="$t('Press enter to select')"
        :selected-label="$t('Selected')"
        :deselect-label="$t('Can\'t remove this value')"
        class="flex-1 outline-none pb-2 text-lg font-sans-medium"
        @input="updateSelected"
      >
        <span slot="noResult">
          Aucun résultat...
        </span>
      </Multiselect>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash';
import Multiselect from 'vue-multiselect';
import BaseLabel from './BaseLabel.vue';

export default {
  name: 'BaseSelect',
  components: {
    BaseLabel,
    Multiselect,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Object, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Choisir une option',
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    selectLabel: {
      type: String,
      default: undefined,
    },
    trackBy: {
      type: String,
      default: undefined,
    },
    valueProperty: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedValue() {
      return find(this.options, option => (option[this.valueProperty] === this.value));
    },
  },
  methods: {
    updateSelected(newValue) {
      if (this.valueProperty) {
        this.$emit('input', newValue[this.valueProperty]);
      } else {
        this.$emit('input', newValue);
      }
    },
  },
};
</script>

<style lang="scss">
.multiselect__option {
  position: relative;

  &::after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 44px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 14px;
    font-weight: normal;
  }
}

.multiselect__option--selected {
  &.multiselect__option--highlight {
    background: #F84F4F;

    &::after {
      color: #FFF;
      background: #F84F4F;
      content: attr(data-deselect);
    }
  }

  &::after {
    content: attr(data-selected);
    color: #7A838E;
  }
}

.multiselect__option--highlight {
  background: #FC6501;
  color: #FFF;

  &::after {
    color: #FFF;
    background: #FC6501;
    content: attr(data-select);
  }
}

.multiselect__option--disabled {
  color: rgba(122, 131, 142, 0.6);
}

.multiselect {
  position: relative;

  .multiselect__content-wrapper{
    box-shadow: 0px 11px 24px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    position: absolute;
    width: 100%;
    background: #FFF;
    overflow-y: auto;
    max-height: 170px !important;
    z-index: 10;
  }

  input {
    width: 100%;
    outline: 0;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    width: 100%;

    li {
      width: 100%;
      border-bottom: 1px solid rgba(122, 131, 142, 0.1);
      > span {
        padding-left: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
        width: 100%;
        cursor: pointer;
        display: block;
      }
    }
  }

  .multiselect__tags {
    border-bottom: 1px solid rgba(122, 131, 142, 0.1);
    padding-bottom: 8px;
    cursor: pointer;
  }

  .multiselect__placeholder {
    color: #7A838E;
  }

  &.multiselect--active {
    &::after {
      background: url('../assets/arrow-up.svg');
    }

    .multiselect__tags {
      border-color: #FF6600;
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    background: url('../assets/arrow-down.svg') no-repeat;
    width: 14px;
    height: 7px;
    background-size: contain;
  }
}
</style>
